import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { navLinks, site } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-accent-800 text-accent-50">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-chat-smile-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg text-background-50">{site.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-accent-100/90">{site.description}</p>
            <p className="mt-4 flex items-center gap-2 text-xs text-accent-200">
              <i className="ri-refresh-line"></i>
              {site.updateNote}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-50">快速导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="inline-flex items-center gap-1.5 text-sm text-accent-100/90 transition-colors hover:text-background-50"
                  >
                    <i className="ri-arrow-right-s-line text-accent-300"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-50">主题分类</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to="/ranking"
                    className="inline-flex items-center gap-1.5 rounded-full bg-accent-900/60 px-3 py-1 text-xs text-accent-50 transition-colors hover:bg-accent-900"
                  >
                    <i className={cat.icon}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-50">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-accent-100/90">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-300"></i>
                <span className="break-all">{site.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-wechat-line mt-0.5 text-accent-300"></i>
                <span>{site.wechat}</span>
              </li>
            </ul>
            <p className="mt-4 rounded-md bg-accent-900/50 px-3 py-2 text-xs leading-relaxed text-accent-100">
              本站只收录免费交流性质的群组，不参与任何收费入群与推广分成。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-accent-700 pt-6 text-xs text-accent-200 sm:flex-row sm:items-center">
          <p>
            © {year} {site.name} · {site.slogan}
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容仅供交流参考，请理性吃瓜</span>
            <Link to="/about" className="transition-colors hover:text-background-50">
              关于我们
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}